<div class="relative w-full top-0 h-[4.6rem] bg-gray-900"></div>

<div [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'">
  <div class="hidden xl:block">
    <div class="w-full">
      <img src="assets\contact\map.webp" width="100%" alt="Map" />
    </div>
    <div class="text-white text-center relative -top-52">
      <div class="flex justify-center items-center">
        <h1
          class="rounded-xl bg-[#1d1d1d] px-4 py-2 font-extrabold"
          style="font-size: 2.25rem"
        >
          {{ "gitInToutch" | transloco }}
        </h1>
      </div>
    </div>
  </div>

  <div class="flex items-center justify-center mt-10 xl:mt-24 mb-4">
    <p
      class="text-center inline-block text-3xl border border-black px-5 py-1 rounded-full"
    >
      {{ "contact" | transloco }}
    </p>
  </div>
  <div
    class="w-11/12 xl:w-9/12 center xl:p-8 rounded-2xl shadow-lg bg-[#dedede17]"
  >
    <form
      *ngIf="contactForm"
      [formGroup]="contactForm"
      (ngSubmit)="onSubmit()"
      autocomplete="off"
    >
      <!-- Name & Last Name -->
      <div class="lg:flex xl:flex gap-4 mb-4">
        <div class="w-full">
          <input
            type="text"
            formControlName="name"
            [placeholder]="'name' | transloco"
            name="name"
            class="w-full px-4 py-3 mb-4 md:mb-0 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
          />
          <div *ngIf="formErrors.name" class="text-red-500 text-sm mt-1">
            {{ formErrors.name }}
          </div>
        </div>

        <div class="w-full">
          <input
            type="text"
            formControlName="lastName"
            [placeholder]="'lastName' | transloco"
            name="lastName"
            class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
          />
          <div *ngIf="formErrors.lastName" class="text-red-500 text-sm mt-1">
            {{ formErrors.lastName }}
          </div>
        </div>
      </div>

      <!-- Country Code + Phone -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <!-- Country Code Dropdown -->
        <div class="col-span-1">
          <div class="relative">
            <mat-select
              id="country"
              [(ngModel)]="selectedCountryIso"
              [ngModelOptions]="{ standalone: true }"
              name="countryIso"
              panelClass="custom-dropdown-panel"
              class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
            >
              <mat-select-trigger>
                <div class="flex items-center">
                  <span
                    class="w-6 h-4 mr-2 overflow-hidden"
                    [style.backgroundImage]="'url(\'/assets/flags/flags.png\')'"
                    [style.backgroundRepeat]="'no-repeat'"
                    [style.backgroundPosition]="
                      getCountryByIso(selectedCountryIso)?.flagImagePos
                    "
                    [style.backgroundSize]="'24px 3876px'"
                  ></span>
                  <span class="font-medium">
                    {{ getCountryByIso(selectedCountryIso)?.code }}
                    {{ getCountryByIso(selectedCountryIso)?.name }}
                  </span>
                </div>
              </mat-select-trigger>

              <mat-option
                *ngFor="let country of countries; trackBy: trackByFn"
                [value]="country.iso"
                (click)="setCountry(country)"
              >
                <div class="flex items-center">
                  <span
                    class="w-6 h-4 mr-2 overflow-hidden"
                    [style.background]="
                      'url(\'/assets/flags/flags.png\') no-repeat ' +
                      country.flagImagePos
                    "
                    [style.backgroundSize]="'24px 3876px'"
                  ></span>
                  <span>{{ country.name }}</span>
                  <span class="ml-2 font-medium text-sm">{{
                    country.code
                  }}</span>
                </div>
              </mat-option>
            </mat-select>
            <div
              *ngIf="
                contactForm.get('prefix')?.invalid &&
                contactForm.get('prefix')?.touched
              "
              class="text-red-500 text-sm mt-1"
            >
              {{ "countryCodeRequired" | transloco }}
            </div>
          </div>
        </div>

        <!-- Phone Number -->
        <div>
          <input
            type="text"
            id="phoneNumber"
            formControlName="phoneNumber"
            [placeholder]="'phoneNumber' | transloco"
            class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
            style="height: 55px"
          />
          <div
            *ngIf="
              contactForm.get('phoneNumber')?.invalid &&
              contactForm.get('phoneNumber')?.touched
            "
            class="text-red-500 text-sm mt-1"
          >
            <span *ngIf="contactForm.get('phoneNumber')?.errors?.required">
              {{ "phoneRequired" | transloco }}
            </span>
            <span *ngIf="contactForm.get('phoneNumber')?.errors?.pattern">
              {{ "phonePatternError" | transloco }}
            </span>
          </div>
        </div>
      </div>

      <!-- Email + Company -->
      <div class="lg:flex xl:flex gap-4 mb-4">
        <div class="w-full">
          <input
            type="email"
            formControlName="email"
            [placeholder]="'email' | transloco"
            name="email"
            class="w-full px-4 py-3 mb-4 md:mb-0 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
          />
          <div *ngIf="formErrors.email" class="text-red-500 text-sm mt-1">
            {{ formErrors.email }}
          </div>
        </div>

        <div class="w-full">
          <input
            type="text"
            formControlName="companyName"
            [placeholder]="'companyName' | transloco"
            name="companyName"
            class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
          />
        </div>
      </div>

      <!-- Message -->
      <div class="w-full mb-4">
        <textarea
          formControlName="message"
          [placeholder]="'message' | transloco"
          name="message"
          rows="4"
          class="w-full px-4 py-3 border bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A67C52]"
        ></textarea>
        <div *ngIf="formErrors.message" class="text-red-500 text-sm mt-1">
          {{ formErrors.message }}
        </div>
      </div>

      <!-- Submit -->
      <div class="py-3">
        <p *ngIf="successMSG" class="text-center text-green-600 text-xl">
          {{ successMSG }}
        </p>
        <button
          type="submit"
          [disabled]="contactForm.invalid || isSubmitting"
          class="my-4 bg-[#E60027] text-white px-4 py-2 center rounded-md disabled:bg-[#ff798f] hover:bg-[#a7001c]"
        >
          {{ "sendMessage" | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
<div class="flex items-center justify-center mt-36 mb-4">
  <p
    class="text-center inline-block text-2xl border border-black px-5 py-1 rounded-full"
    [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'"
  >
    {{ "getInToutch" | transloco }}
  </p>
</div>
<div
  class="w-11/12 lg:w-5/6 xl:w-5/6 center px-8 pt-3 pb-5 rounded-2xl shadow-lg bg-[#dedede17]"
>
  <p
    class="text-center text-3xl"
    [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'"
  >
    {{ "salesDepartment" | transloco }}
  </p>
  <div class="w-full py-3">
    <hr />
  </div>
  <div class="grid lg:flex xl:flex">
    <div class="w-full lg:w-1/3 xl:w-1/3 grid justify-center">
      <a class="hover:text-[#E60027] text-xl" href="tel:+905301485665"
        ><i class="fas fa-mobile-alt"></i> : +90 530 148 56 65
      </a>
      <br />
      <a class="hover:text-[#E60027] text-xl" href="tel:+903425023161"
        ><i class="fas fa-phone-volume"></i> : +90 (342) 502 31 61
      </a>
    </div>
    <div
      class="w-full lg:w-2/3 xl:w-2/3 grid justify-center text-center mt-4 lg:mt-0 xl:mt-0"
    >
      <a
        class="hover:text-[#E60027] text-xl"
        href="mailto:info@zirvecompany.com"
        ><i class="fa-regular fa-envelope"></i> : info&#64;zirvecompany.com
      </a>
      <br />
      <span
        ><i class="fa-solid fa-location-dot"></i>
        <a
          class="hover:text-[#E60027] text-xl"
          target="_blank"
          href="https://www.google.com/maps/place/Z%C4%B0RVE+%C4%B0NTERNAT%C4%B0ONAL/@37.0635676,37.4491954,17z/data=!4m5!3m4!1s0x1531e14ed879e753:0x8a654126dfac1b85!8m2!3d37.0635676!4d37.4513841"
        >
          : Sanayi Mah. 60352 sok . NO :29 Şehitkamil / Gaziantep / Türkiye
        </a>
      </span>
    </div>
  </div>
</div>
<div class="flex items-center justify-center mt-36 mb-4">
  <p
    class="text-center inline-block text-3xl border border-black px-5 py-1 rounded-full"
    [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'"
  >
    {{ "folowUs" | transloco }}
  </p>
</div>

<div
  class="w-11/12 lg:w-3/6 xl:w-3/6 center px-8 py-5 rounded-2xl shadow-lg bg-[#dedede17]"
>
  <div
    class="grid grid-cols-5 md:grid-cols-9 lg:grid-cols-8 justify-around items-center gap-5"
  >
    <a href="https://twitter.com/zirveextrusion" target="_blank" matTooltip="X">
      <img
        class="mx-auto"
        src="assets\contact\x.png"
        loading="lazy"
        alt="X Logo"
    /></a>
    <a
      href="https://www.facebook.com/zirveextrusion"
      target="_blank"
      matTooltip="Facebook"
    >
      <img
        class="mx-auto"
        src="assets\contact\face.png"
        loading="lazy"
        alt="X Logo"
      />
    </a>
    <a
      href="https://www.instagram.com/zirveextrusion/"
      target="_blank"
      matTooltip="Instagram"
    >
      <img
        class="mx-auto"
        src="assets\contact\insta.png"
        loading="lazy"
        alt="X Logo"
      />
    </a>
    <a
      href="https://www.youtube.com/channel/UCLvw13OLb5NJrE35Z9WkiRA"
      target="_blank"
      matTooltip="Youtube"
    >
      <img
        class="mx-auto"
        src="assets\contact\youtube.png"
        loading="lazy"
        alt="X Logo"
      />
    </a>
    <a href="https://wa.me/+905301485665" target="_blank" matTooltip="Whatsapp">
      <img
        class="mx-auto"
        src="assets\contact\whatsapp.png"
        loading="lazy"
        alt="X Logo"
      />
    </a>
    <a
      href="https://www.tiktok.com/@zirveextrusion"
      target="_blank"
      matTooltip="Tiktok"
    >
      <img
        class="mx-auto"
        src="assets\contact\tiktok.png"
        loading="lazy"
        alt="X Logo"
      />
    </a>
    <a
      href="https://www.linkedin.com/company/zirve-extrusion/about/"
      target="_blank"
      matTooltip="Linkedin"
    >
      <img
        class="mx-auto"
        src="assets\contact\linkedin.png"
        loading="lazy"
        alt="X Logo"
      />
    </a>
    <a
      href="https://tr.pinterest.com/zirveextrusion/"
      target="_blank"
      matTooltip="Pinterest"
    >
      <img
        class="mx-auto"
        src="assets\contact\preset.png"
        loading="lazy"
        alt="X Logo"
      />
    </a>
  </div>
</div>
<div [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'">
  <div class="flex items-center justify-center mt-10 xl:mt-36 mb-4">
    <p
      class="text-center inline-block text-3xl border border-black px-5 py-1 rounded-full"
    >
      {{ "SALESMANAGERS" | transloco }}
    </p>
  </div>

  <div class="md:flex px-3 lg:px-40 text-center mt-10">
    <div class="w-full md:w-1/3">
      <img class="mx-auto" src="assets/contact/m3.webp" width="25%" alt="" />
      <a
        class="flex items-center justify-center mx-16"
        href="https://wa.me/+905301485665"
        target="_blank"
      >
        <img
          class="w-6 mr-1"
          src="assets\contact\whatsapp.png"
          loading="lazy"
          alt="X Logo"
        />
        <span class="text-blue-600"> {{ "directContact" | transloco }} </span>
      </a>
      <p class="text-base lg:text-2xl font-extrabold">Ghaith ZIDAN</p>
      <p class="font-bold">
        {{ "m3" | transloco }}
      </p>
    </div>
    <div class="w-full md:w-1/3">
      <img class="mx-auto" src="assets/contact/m2.webp" width="25%" alt="" />
      <a
        class="flex items-center justify-center mx-16"
        href="https://wa.me/+905497363701"
        target="_blank"
      >
        <img
          class="w-6 mr-1"
          src="assets\contact\whatsapp.png"
          loading="lazy"
          alt="X Logo"
        />
        <span class="text-blue-600"> {{ "directContact" | transloco }} </span>
      </a>
      <p class="text-base lg:text-2xl font-extrabold">Aiman HADRI</p>
      <p class="font-bold">
        {{ "m2" | transloco }}
      </p>
    </div>
    <div class="w-full md:w-1/3">
      <img class="mx-auto" src="assets/contact/m1.webp" width="25%" alt="" />
      <a
        class="flex items-center justify-center mx-16"
        href="https://wa.me/+905616116610"
        target="_blank"
      >
        <img
          class="w-6 mr-1"
          src="assets\contact\whatsapp.png"
          loading="lazy"
          alt="X Logo"
        />
        <span class="text-blue-600"> {{ "directContact" | transloco }} </span>
      </a>
      <p class="text-base lg:text-2xl font-extrabold">Bayram GÜZEL</p>
      <p class="font-bold">
        {{ "m1" | transloco }}
      </p>
    </div>
  </div>
</div>
<div class="my-60"></div>
